'use strict';

module.exports = emphasis;

var all = require('../all');

/* Transform emphasis. */
function emphasis(h, node) {
  return h(node, 'em', all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/mdast-util-to-hast/lib/handlers/emphasis.js
// module id = 964
// module chunks = 0